exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".monitor-list_monitor-list_aXinQ {\n    /* Width/height are set by the component, margin: auto centers in fullscreen */\n    margin: auto;\n    pointer-events: none;\n    overflow: hidden;\n}\n\n.monitor-list_monitor-list-scaler_1jxP7 {\n    /* Scaling for monitors should happen from the top left */\n    -webkit-transform-origin: left top;\n        -ms-transform-origin: left top;\n            transform-origin: left top;\n}\n\n::-ms-clear { display: none; }\n", ""]);

// exports
exports.locals = {
	"monitor-list": "monitor-list_monitor-list_aXinQ",
	"monitorList": "monitor-list_monitor-list_aXinQ",
	"monitor-list-scaler": "monitor-list_monitor-list-scaler_1jxP7",
	"monitorListScaler": "monitor-list_monitor-list-scaler_1jxP7"
};